import { defineStore } from 'pinia';

export const useUserStore = defineStore('user', {
 state: () => ({
  user: null,
  isAuthenticated: false,
  badgePickupOpened: true,
 }),
 actions: {
  async fetchUser() {
   if (!this.isAuthenticated) {
    return;
   }
   try {
    const response = await $fetch('/api/v1/user/me', {
     method: 'GET',
     params: {
      email: this.user.email,
      ticketId: this.user.ticketId,
     },
    });
    this.user = response;
   } catch (error) {
    console.error('Error fetching user:', error);
    if (error.response && (error.response.status === 404 || error.response.status === 500)) {
     this.logout();
    }
   }
  },
  async authenticate(email, ticketId) {
   console.log('authenticate', email, ticketId);
   try {
    const response = await $fetch('/api/v1/registration', {
     method: 'POST',
     body: {
      email,
      ticketId,
     },
    });

    if (response) {
     this.user = response;
     console.log('this.user', this.user);
     this.isAuthenticated = true;
    } else {
     throw new Error('Authentication failed');
    }
   } catch (error) {
    console.error('Authentication failed:', error);
    throw error;
   }
  },
  async registerTicket(sessionId) {
   try {
    if (!this.isAuthenticated || !this.user) {
     throw new Error('User not authenticated');
    }

    if (!this.user.email || !this.user.ticketId) {
     throw new Error('User email or ticket ID is missing');
    }

    const response = await $fetch('/api/v1/session/register', {
     method: 'POST',
     body: {
      email: this.user.email,
      ticketId: this.user.ticketId,
      session_id: sessionId,
      now: new Date().toISOString(),
      version: '1',
     },
    });

    console.log('Ticket registered for session:', response);
    return response;
   } catch (error) {
    console.error('Error registering ticket:', error);
    throw error;
   }
  },

  async unregisterTicket(sessionId) {
   try {
    if (!this.isAuthenticated || !this.user) {
     throw new Error('User not authenticated');
    }

    const response = await $fetch('/api/v1/session/unregister', {
     method: 'POST',
     body: {
      email: this.user.email,
      ticketId: this.user.ticketId,
      session_id: sessionId,
     },
    });

    return response;
   } catch (error) {
    console.error('Error unregistering ticket:', error);
    throw error;
   }
  },
  async favoriteSession(sessionId) {
   try {
    if (!this.isAuthenticated || !this.user) {
     throw new Error('User not authenticated');
    }

    if (!this.user.email || !this.user.ticketId) {
     throw new Error('User email or ticket ID is missing');
    }

    const response = await $fetch('/api/v1/session/favorite', {
     method: 'POST',
     body: {
      email: this.user.email,
      ticketId: this.user.ticketId,
      sessionId,
     },
    });

    console.log('Session added to favorites:', response);

    // Update the user's favorites in the store
    if (this.user.favorites) {
     this.user.favorites.push(sessionId);
    } else {
     this.user.favorites = [sessionId];
    }

    return response;
   } catch (error) {
    console.error('Error adding session to favorites:', error);
    throw error;
   }
  },

  async unfavoriteSession(sessionId) {
   try {
    if (!this.isAuthenticated || !this.user) {
     throw new Error('User not authenticated');
    }

    if (!this.user.email || !this.user.ticketId) {
     throw new Error('User email or ticket ID is missing');
    }

    const response = await $fetch('/api/v1/session/unfavorite', {
     method: 'POST',
     body: {
      email: this.user.email,
      ticketId: this.user.ticketId,
      sessionId,
     },
    });

    console.log('Session removed from favorites:', response);

    // Update the user's favorites in the store
    if (this.user.favorites) {
     this.user.favorites = this.user.favorites.filter((favoriteId) => favoriteId !== sessionId);
    }

    return response;
   } catch (error) {
    console.error('Error removing session from favorites:', error);
    throw error;
   }
  },
  logout() {
   this.user = null;
   this.isAuthenticated = false;
  },
  setBadgePickupOpened(value) {
   this.badgePickupOpened = value;
  },
 },
});
